// Server BASE URL
export const BASE_URL = 'https://violationapi.iosuite.org/api';
// export const BASE_URL = 'http://127.0.0.1:8000/api';

// MA Cargo API BASE URL
export const BASE_URL_2 = 'https://macargo.abooderp.com/api/v1';

// ABS Driver BASE URL
export const BASE_URL_3 = 'https://ghrm.abooderp.com/api';

// Storage Routes
// export const BASE_URL_5 = 'http://127.0.0.1:8000';
export const BASE_URL_5 = 'https://violationapi.iosuite.org';

// TMS API BASE URL
export const TMS_BASE_URL = 'https://tms.tpf.go.tz/api';

// Temporary
export const BASE_URL_6 = 'https://abs.iosuite.org/api/v1';